import TimeoffNotificationDetail from "../pages/mobile/notificationDetail/timeoff";
import ShiftSwapNotificationDetail from "../pages/mobile/notificationDetail/shiftSwap";
import GeofenceNotificationDetail from "../pages/notificationDetailsV2/GeofenceNotificationDetail";
import OpenShiftNotificationDetail from "../pages/notificationDetailsV2/OpenShiftNotificationDetail";
import { OpenShiftAvailableNotificationDetail } from "../pages/notificationDetailsV2";
import EmployeeTimecardRequestNotificationDetail from "../pages/notificationDetailsV2/EmployeeTimecardRequestNotificationDetail";
import TimesheetApprovalsNotificationDetail from "../pages/notificationDetailsV2/TimesheetApprovalsNotificationDetail";
import UnavailabilityNotificationDetail from "../pages/notificationDetailsV2/UnavailabilityNotificationDetail";
import MealBreakNotificationDetail from "../pages/notificationDetailsV2/MealBreakNotificationDetail";
import EmployeeExtraHoursNotificationDetail from "../pages/mobile/notificationDetail/employeeExtraHours";

export const notificationComponents: Record<string, React.ElementType> = {
    TIMEOFF_APPROVAL: TimeoffNotificationDetail,
    SHIFT_SWAPPING: ShiftSwapNotificationDetail,    
    EMP_GEOFENCE_VIOLATION: GeofenceNotificationDetail,
    GEOFENCE: GeofenceNotificationDetail,
    OPEN_SHIFT_WORK: OpenShiftNotificationDetail,
    OPEN_SHIFT_AVAILABLE: OpenShiftAvailableNotificationDetail,
    EMPLOYEE_TIMECARD_REQUEST: EmployeeTimecardRequestNotificationDetail,
    TIMECARD_MEAL_BREAK: MealBreakNotificationDetail,
    TIMECARD_APPROVAL: TimesheetApprovalsNotificationDetail,
    EMPLOYEE_UNAVAILABLITY: UnavailabilityNotificationDetail,
    EMPLOYEE_EXTRA_HOURS: EmployeeExtraHoursNotificationDetail,
};
